"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inline = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = __importDefault(require("./icons"));
var classes_1 = require("../utils/classes");
var Inline = function (_a) {
    var className = _a.className, title = _a.title, _b = _a.type, type = _b === void 0 ? 'success' : _b, icon = _a.icon;
    var _icon = icon;
    if (!_icon) {
        // if (type === 'success') {
        _icon = 'tick-circle';
        // }
    }
    return (react_1.default.createElement("div", { className: classnames_1.default(classes_1.addClassName('notification-inline'), 'flex flex-col-reverse lg:flex-row items-center justify-between rounded p-6 text-white', type === 'success' && 'bg-success', className) },
        react_1.default.createElement("h3", null, title),
        react_1.default.createElement("div", { className: "flex-end align-right mb-6 lg:mb-0" },
            react_1.default.createElement(icons_1.default, { icon: _icon, size: 24, className: "text-white" }))));
};
exports.Inline = Inline;
//# sourceMappingURL=notifications.js.map